import { PlannerMemo } from 'mixs/orders/planner_base';
import { Global, CellPositionLocal, LineMemoLocal }  from "mixs/orders/planner/model";
import moment from 'moment';
class Cell extends PlannerMemo {
  setBackgroundColor(){
  }
  newCellPosition(){
    return new CellPositionLocal(this.opts.baseDate, this.opts.start_time, this.opts.end_time);
  }
  newLineMemoLocal(localIndex){
    return new LineMemoLocal(this.opts.line_id, this.opts.id, localIndex, this.opts.baseDate);
  }
  genTagScopeForDeliveryRecord(index){
    let dateStr = moment(this.opts.start_time).add(index, 'day').format('YYYYMMDD');
    let taskable_id = this.getTaskData(this.opts.task_id).taskable_id;
    let scope = 'delivery_record_' + taskable_id + '_' + dateStr;
    return scope;
  }
}
riot.mixin('tasks.delivered-cell', Cell as riot.TagMixin)
